module.exports = [{"type":"title","text":"2023-08-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Spot: new  <a href='https://bingx-api.github.io/docs/#/spot/market-api.html#24%E5%B0%8F%E6%97%B6%E4%BB%B7%E6%A0%BC%E5%8F%98%E5%8A%A8%E6%83%85%E5%86%B5'  target='_blank'>24-hour price changes</a> interface"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2023-08-23.json
// module id = CcT1
// module chunks = 3